import createRoute from '@widesk-ui/tools/createRoute';

const route = createRoute.customFromService(
	`Purge manuelle du cache`,
	'/configuration/cache_purge',
	'website',
	'CachePurge',
);

export default route;
